
















































import { Component, Prop } from 'vue-property-decorator';
import Form, {Send} from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import RuleSettings from './rule-settings.vue';
import api, { BotFiltersApi } from '../api';
const md5 = require('md5');

@Component({
  components: {
    FormOverlay,
    DialogForm,
    RuleSettings,
    ErrorAggregator,
  }
})
export default class AddBotDetectionRules extends Form {
  @Prop({ default: {} })
  data: any;

  api: BotFiltersApi = api;
  show: boolean = false;
  isLoadingDictionary: boolean = false;

  active_name: string = '';
  active_id: string = '';
  active_rule: any = this.getDefaultActiveRule();
  relation: string = 'and';

  getDefaultActiveRule() {
    return {
      conditions: {}
    };
  }

  errors: any[] = [];
  errorsControlActive: boolean = false;

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.getForm()));
  }

  getForm() {
    return {
      rules: this.active_rule.conditions,
      name: this.active_name,
      logicalRelation: this.relation,
      status: 'active',
    };
  }

  get self() {
    return this;
  }

  open() {
    const { id } = this.data
    this.$store.commit('loading', true);
    if(id) {
      this.api.getById(id).then((res: any) => {
        this.active_rule.conditions = res.rules;
        this.active_name = res.name;
        this.active_id = res.id;
        this.relation = res.logicalRelation || 'and';
        this.show = true;

        this.oldHash = this.getCurrentHash();
        this.$store.commit('loading', false);
      });
    } else {
      this.active_rule = this.getDefaultActiveRule();
      this.active_name = '';
      this.active_id = '';
      this.relation = 'and';
      this.show = true;

      this.oldHash = this.getCurrentHash();

      this.$store.commit('loading', false);
    }
  }

  onSaveDictionary(isLoading) {
    this.isLoadingDictionary = isLoading
  }

  mounted() {
    const $on = this.$on.bind(this);

    $on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);
      this.api.loading = false;

      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });

    this.bus.on('loading-add-dictionary', this.onSaveDictionary);

    this.open()

    this.$nextTick(()=> {
      const ruleSettings = this.$refs.ruleSettings as RuleSettings;

      if (ruleSettings) {
        ruleSettings.conditions.forEach((e: any) => {
          e.selected = false;
        });

        ruleSettings.resetValidation();
      }
    })
  }

  beforeDestroy() {
    this.bus.off('loading-add-dictionary', this.onSaveDictionary);
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  @Send()
  save() {
    if (this.isLoadingDictionary) return

    const form = this.getForm();

    if (!this.active_id) {
     return this.api
        .post(form)
        .then(() => {
          this.api.get().then(()=>{
            this.$emit('save');
            this.trackAnalytics('bot_detection_rules_create',form);
            this.close();
            this.bus.emit('toast-success', this.t('Bot rule has been successfully added'));
          });
        });
    } else {
      return this.api
        .putRules(this.active_id, form)
        .then(() => {
          this.api.get().then(()=>{
            this.$emit('save');
            this.trackAnalytics('bot_detection_rules_edit',form);
            this.close();
            this.bus.emit('toast-success', this.t('Bot rule has been changed'));
          });
        });
    }
  }

  close() {
    this.$emit('close');
  }

  trackAnalytics(event,form){
    const {name} = form;
    const rules= Object.keys(form.rules).reduce((acc,rule)=>{
      acc.push(rule)
      return acc;
    },[]) || []

    this.$mixpanel?.track(event, {
      name,
      rules
    })
  }
}
